module.exports = __webpack_public_path__ + "static/img/news13.fffcc51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news13.jpg
// module id = BlgA
// module chunks = 1